import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">精彩视频</h2>
        <p className="section-subtitle">幕后花絮、深度解析、主创访谈，更多精彩视频内容</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaData.map((item) => (
            <article
              key={item.title}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-background-950/20 group-hover:bg-background-950/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs bg-background-950/70 text-background-50 rounded">
                  {item.duration}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500">
                  <i className="ri-eye-line mr-1"></i>
                  {item.views} 次观看
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}